/**
 * Shared HTML escaping utilities.
 *
 * Uses the browser-native textContent/innerHTML pattern to escape
 * HTML entities safely without regex.
 */

const _escapeDiv = document.createElement('div');

/**
 * Escape a string for safe insertion into innerHTML.
 * Converts <, >, &, etc. into their HTML entity equivalents.
 *
 * @param {string} str - The string to escape
 * @returns {string} The escaped string
 */
export function escapeHtml(str) {
  if (str == null) return '';
  _escapeDiv.textContent = String(str);
  return _escapeDiv.innerHTML;
}

/**
 * Escape a string for safe use in an HTML attribute value.
 * In addition to standard HTML escaping, also escapes double quotes.
 *
 * @param {string} str - The string to escape
 * @returns {string} The escaped string (safe for use inside double-quoted attributes)
 */
export function escapeAttr(str) {
  if (str == null) return '';
  return escapeHtml(str).replace(/"/g, '&quot;');
}
